const BASE = '/Department';

export default {
  getAll(api) {
    return api.get(BASE);
  },
  create(api, params) {
    return api.post(BASE, params);
  },
  update(api, id, params) {
    return api.put(`${BASE}/${id}`, params);
  },
  remove(api, id) {
    return api.delete(`${BASE}/${id}`);
  },
  assignRole(api, departmentId, roleId) {
    return api.post(`${BASE}/${departmentId}/role-assignments`, { roleId });
  },
  removeRole(api, departmentId, roleId) {
    return api.delete(`${BASE}/${departmentId}/role-assignments/${roleId}`);
  },
};
